const chartDeal = {
  data: () => ({
    interval: 'one',
    chartData: {},
    options: {},
    plugin: {},
    labels: [],
    values: [],
    deals: [],
    show: false,
  }),

  methods: {
    getList () {
      this.show = this.isValid(this.data);

      if (this.show) {
        if (this.name === 'deal.progress') {
          this.list = this.data.data[0].items[0].stages || [];
        } else {
          this.list = this.data.data[0].items || [];
        }

        this.getChartData();
      }
    },

    setChartData (labels, data0, data1) {
      this.chartData = {
        datasets: [data0, data1],
        labels,
      };
    },

    setOptions (scales, average) {
      this.options = {
        scales,
        tooltips: {
          enabled: false,
          position: 'custom',
          callbacks: {
            label: (t, d) => {
              let datasetLabel = d.datasets[t.datasetIndex].label;
              let value = t.xLabel;

              if (t.datasetIndex) {
                value = `R$ ${parseFloat(value).toFixed().split(/(?=(?:...)*$)/).join('.')}`;
              }

              datasetLabel = `<span class="chartjs-tooltip-label">${datasetLabel.toUpperCase()}</span> `;
              value = `<span class="chartjs-tooltip-value">${value}</span>`;

              return datasetLabel + value;
            },
          },
        },
        horizontalPoint: {
          pointBackgroundColor: this.background[1],
          pointBorderColor: 'white',
        },
        annotation: {
          annotations: [
            {
              drawTime: 'afterDatasetsDraw',
              id: 'averageLine',
              type: 'line',
              mode: 'vertical',
              scaleID: 'x-axis-bottom',
              value: average,
              borderColor: 'black',
              borderWidth: 1,
              label: {
                fontColor: '#3B334A',
                backgroundColor: '#F4F2F7',
                cornerRadius: 2,
                content: `${this.__('Média')}: ${average}`,
                enabled: true,
                position: 'bottom',
                xAdjust: -40,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      };
    },

    setPlugin () {
      this.plugin = {
        id: 'horizontalPoint',
        beforeInit: (chart) => {
          const chartOptions = chart.options;

          chart.hPoint = chartOptions.horizontalPoint || {};
          chart.hPoint.pointRotation = chart.hPoint.pointRotation || 0;
          chart.hPoint.pointBorderWidth = chart.hPoint.pointBorderWidth || 2;
          chart.hPoint.pointBorderColor = chart.hPoint.pointBorderColor || 'rgba(0,0,0,0.1)';
          chart.hPoint.pointBackgroundColor = chart.hPoint.pointBackgroundColor || 'rgba(0,0,0,0.1)';
        },
        afterDatasetsDraw: (chart) => {
          const { ctx } = chart.chart;
          const meta = chart.getDatasetMeta(1);
          const points = meta.data || [];
          const ilen = points.length;

          ctx.save();
          ctx.lineWidth = chart.hPoint.pointBorderWidth;
          ctx.strokeStyle = chart.hPoint.pointBorderColor;
          ctx.fillStyle = chart.hPoint.pointBackgroundColor;

          for (let i = 0; i < ilen; ++i) {
            const vm = points[i]._view;
            const { x } = vm;
            const { y } = vm;
            const radius = vm.height / 2;

            if (x === vm.base) {
              return;
            }

            ctx.beginPath();
            ctx.arc(x, y, radius, 0, Math.PI * 2);
            ctx.closePath();
            ctx.fill();
            ctx.stroke();
          }
        },
      };
    },

    getChartData () {
      this.labels = [];
      this.values = [];
      this.deals = [];

      this.list.forEach((element) => {
        if (this.name === 'deal.progress') {
          this.labels.push(this.getStageName(element.id));
        } else {
          this.labels.push(this.getUserName(element.id));
        }

        this.values.push(element.total);
        this.deals.push(element.count);

        this.count += element.count;
        this.total += element.total;
      });

      if (this.list.length) {
        this.averageCount = this.count / this.list.length;
        this.averageTotal = this.total / this.list.length;
      }

      const percentage = this.labels.length / 35;

      const data0 = {
        xAxisID: 'x-axis-bottom',
        label: 'Negócios',
        data: this.deals,
        categoryPercentage: percentage,
        backgroundColor: this.background[1],
      };

      const data1 = {
        xAxisID: 'x-axis-top',
        label: 'Valor',
        data: this.values,
        categoryPercentage: percentage,
        backgroundColor: 'transparent',
      };

      this.setChartData(this.labels, data0, data1);
      this.setOptions(this.getScales(), this.averageCount.toFixed());
      this.setPlugin();
    },

    getScales () {
      const yAxisLabel = {
        stacked: true,
        ticks: {
          callback: (value) => (value.length > 20 ? value.substring(0, 17).concat('...') : value),
          fontSize: 12,
          fontStyle: 400,
          fontWeight: 400,
          fontColor: '#242424'
        },
        gridLines: {
          display: true,
          drawBorder: false,
          offsetGridLines: false,
          borderDash: [3],
          color: '#e0dbe8',
        },
      };

      const ticks = this.getTicks();

      const xAxisBottom = {
        id: 'x-axis-bottom',
        type: 'linear',
        position: 'bottom',
        ticks: ticks.bottom,
        gridLines: {
          display: true,
          drawBorder: false,
          drawOnChartArea: true,
          offsetGridLines: false,
          borderDash: [3],
          zeroLineWidth: 0,
          color: '#e0dbe8',
          drawTicks: true,
        },
      };

      const xAxisTop = {
        id: 'x-axis-top',
        type: 'linear',
        position: 'top',
        ticks: ticks.top,
        gridLines: {
          display: false,
          drawBorder: false,
        },
      };

      return {
        xAxes: [xAxisBottom, xAxisTop],
        yAxes: [yAxisLabel],
      };
    },

    getTicks () {
      let maxTop = this.values.reduce((a, b) => Math.max(a, b), -Infinity);
      let maxBottom = this.deals.reduce((a, b) => Math.max(a, b), -Infinity);
      const ticks = 10;

      maxTop = this.newMax(maxTop, ticks);
      maxBottom = this.newMax(maxBottom, ticks);

      const stepTop = this.newStep(maxTop, ticks);
      const stepBottom = this.newStep(maxBottom, ticks);

      maxTop = ticks * stepTop;
      maxBottom = ticks * stepBottom;

      return {
        top: {
          callback: (value) => (value >= 1000 ? `R$ ${value / 1000}K` : `R$ ${value}`),
          beginAtZero: true,
          max: maxTop || 1000,
          stepSize: stepTop || 1000,
          fontSize: 10,
          fontStyle: 400,
          fontWeight: 400,
          fontColor: '#242424'
        },
        bottom: {
          beginAtZero: true,
          max: maxBottom || 1,
          stepSize: stepBottom || 1,
          fontSize: 10,
          fontStyle: 400,
          fontWeight: 400,
          fontColor: '#242424'
        },
      };
    },

    newMax (max, ticks) {
      if (max % ticks === 0) {
        return max;
      }

      if (max !== -Infinity && max <= ticks / 2) {
        return ticks / 2;
      }

      return max + ticks - (max % ticks);
    },

    newStep (max, ticks) {
      let step = max / ticks;
      const len = step.toString().slice(2).length;

      if (len) {
        step = parseInt(step.toString().slice(0, 2), 10) + 1;
        step *= 10 ** len;
      }

      if (max && max < ticks) {
        step = 0.5;
      }

      return step;
    },
  },
};

export default chartDeal;
